import { combineReducers } from 'redux';

import analytics from './analytics/reducer';
import bundles from './bundles/reducer';
import configs from './configs/reducer';
import data from './data/reducer';
import dialogs from './dialogs/reducer';
import fields from './fields/reducer';
import groups from './groups/reducer';
import home from './home/reducer';
import offers from './offers/reducer';
import page from './page/reducer';
import progress from './progress/reducer';
import refs from './refs/reducer';
import resources from './resources/reducer';
import session from './session/reducer';
import theme from './theme/reducer';
import timeOut from './timeOut/reducer';
import ui from './ui/reducer';

export default combineReducers({
  analytics,
  bundles,
  configs,
  data,
  dialogs,
  fields,
  groups,
  home,
  offers,
  page,
  progress,
  refs,
  resources,
  session,
  theme,
  timeOut,
  ui,
});
